import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/**
 * SearchbarComponent
 *
 * @export SearchbarComponent
 */
@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})

export class SearchbarComponent implements OnInit {
  /**
   * email search term used for SearchResultsComponent
   */
  searchTerm = '';

  /**
   * Creates an instance of SearchbarComponent.
   * @param router used to navigate routes
   */
  constructor(private router: Router) { }

  /**
   * Does nothing
   */
  ngOnInit() {
  }

  /**
   * Calls route navigation with url search params
   */
  search(): void {
    this.router.navigate(['search', this.searchTerm]);
  }
}
